import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      camper, // via query
      session, // via query
      camperSession, // via query
      product, // via query
      setCartProduct // via redux actions
    } = props

    const handleChangeProduct = e => {
      const selectedType = e.target.value
      setCartProduct({ camper, session, camperSession, product, selectedType })
    }

    return <WrappedComponent onChangeProduct={handleChangeProduct} {...props} />
  }
}

export default withEventHandlers
